import { HORIZONTAL_SCROLL_ITEM_IDENTIFIER_ATTRIBUTE } from '../constants';
export const getHorizontalScrollItems = (container) => {
    return [
        ...container.querySelectorAll(`[${HORIZONTAL_SCROLL_ITEM_IDENTIFIER_ATTRIBUTE}]`),
    ];
};
